import Joi from "joi";

export const documentTemplateSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  content: Joi.string().min(2).label("Content"),
  documentType: Joi.number().min(0).label("DocumentType"),
});
